import yup from '../../../../config/yup';

export const s3DirectoryListTaskValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('fileOperation'),
  function: yup.string().default('s3DirectoryList'),
  parameters: yup.object().shape({
    s3Bucket: yup.string().required('S3 Bucket is required'),
    prefix: yup.string(),
    recursive: yup.boolean(),
    awsAccessKeyId: yup.string().required('AWS Access Key ID is required'),
    awsSecretAccessKey: yup.string().required('AWS Secret Access Key is required'),
  }),
});
